import { Module } from "vuex";
import { RootState, FavoritesState } from "@/types/favorites";
import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";

const state: FavoritesState = {
  addRecipeResult: null,
  deleteRecipeResult: null,
  recentMylist: null,
  mylist: null,
  folderList: null,
  folderRecipeList: null,
  registFolderResult: null,
  renameFolderResult: null,
  deleteFolderResult: null,
  addFolderRecipeResult: null,
  deleteFolderRecipeResult: null,
  folderMoveResult: null,
  folderName: null,
  sendedHistory: null,
  viewedHistory: null,
  selectedTab: 0
};

export const favorites: Module<FavoritesState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
